import { CarouselWidget } from 'components/widgets/carousel-widget';
import React, { useState } from 'react';
import './index.scss';
import { ConditionPickerWidgetProps } from './structs';

const ConditionPickerWidget = (props: ConditionPickerWidgetProps) => {
    const [selectedIndex, setSelectedIndex] = useState<number>(0);

    const slidesFactory = () => {
        return props?.conditionGroups?.map((item, i) => (
            <swiper-slide key={`slide-${i}`} class="slide" onClick={() => setSelectedIndex(i)}>
                <div className={`tile ${selectedIndex === i ? 'selected' : ''}`}>{item.groupDisplayName}</div>
            </swiper-slide>
        ))
    }
    const groupLength = props?.conditionGroups?.length ?? 0;
    if (groupLength <= 0) {
        return <></>
    }
    const conditions = props?.conditionGroups[Math.max(Math.min(selectedIndex, groupLength), 0)].conditions ?? [];

    return (<div className='kyanite-condition-picker-container'>
        <div className='head'>
            <CarouselWidget stretch={props.stretchHead} slidesFactory={slidesFactory} />
        </div>
        <div className='content'>
            {conditions.map((condition, j) => (
                <div className='card' key={`content-card-${j}`}>
                    <a href={condition.link} className='card-inner' key={`content-card-inner-${j}`}>
                        <span>{condition.title}</span>
                    </a>
                </div>
            ))}
        </div>
    </div>)
};

export default ConditionPickerWidget;
